import React from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as DeleteDiagnosisPopupIcon } from "../../assets/svg/delete-new-icon.svg";
import { ErrorButton, OutlinedButton, PrimaryButton } from "../customComponent/Button";
import { PopupStyledModal } from "../customComponentNewDesign/CustomPopupModal";
import { font18pxSB } from "../Typography";
import styled from "styled-components";

const DialogTitle = styled.p`
  ${font18pxSB}
`;

const DiscardChangesPopup = ({
  visible = true,
  onClickDiscard = () => {},
  onClickCancel = () => {},
  popupTitle,
  popupDescription,
  okText,
  cancelText,
  usePrimaryButton = false
}) => {
  const { t } = useTranslation();
  const OkButton = usePrimaryButton ? PrimaryButton : ErrorButton;
  return (
    <PopupStyledModal
      title={<DeleteDiagnosisPopupIcon />}
      open={visible}
      closable={false}
      footer={[
        <OutlinedButton key="back" onClick={onClickCancel} id="discard_changes_cancel">
          {cancelText || t("back")}
        </OutlinedButton>,
        <OkButton key="ok" onClick={onClickDiscard} id="discard_changes_ok">
          {okText || t("approve_discard")}
        </OkButton>
      ]}
    >
      <DialogTitle>{popupTitle}</DialogTitle>
      {popupDescription ? popupDescription : t("cancel_modal_description")}
    </PopupStyledModal>
  );
};

export default DiscardChangesPopup;
